import { render, staticRenderFns } from "./StandardClauseForm.vue?vue&type=template&id=ac88e940&scoped=true&"
import script from "./StandardClauseForm.vue?vue&type=script&lang=js&"
export * from "./StandardClauseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac88e940",
  null
  
)

export default component.exports